import { InjectionToken } from '@angular/core';
export interface CartMessagesTranslations {
  addToCartSuccessTitle: string;
  addToCartSuccessMessage: (count: number, productName?: string) => string;
  goToCartLabel: string;
  roundUpMessage: {
    headline: string;
    copy: (count: number) => string;
  };
}

export const CART_MESSAGES_TRANSLATIONS = new InjectionToken<CartMessagesTranslations>('CART_MESSAGES_TRANSLATIONS');
